<ng-content select="ssc-header"></ng-content>

<main [class]="containerSize">
  <section>
    <ng-content></ng-content>
  </section>
</main>

<div class="footer-divider">
  <ssc-footer [class]="containerSize" [showContactButton]="showFooterContactButton"></ssc-footer>
</div>
<ssc-error-popup></ssc-error-popup>
